import { Container, Row, Col, Image } from "react-bootstrap";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/pagination';
import { Pagination, Autoplay } from 'swiper/modules';
import {
  OurStoryBanner,
  OurStorySection,
  OurStoryImage,
  StoryGreatNonprofits,
  StoryTitle,
  StoryText,
  StoryImageSection,
  GreatNonprofitsMission,
  GreatNonprofitsGreen,
  GreatImage,
  GreatGreenText,
  NonprofitSlider,
  SliderTitle,
  SliderWrapper,
  SliderItemTitle,
  SliderSwiperItem,
  NonprofitOrganization,
  OrganizationText,
} from './ourStoryStyle';
import Story from '../../../assests/images/story.webp';
import StoryGreatImage from '../../../assests/images/storyofgreatnonprofits.webp';
import BlogCard from "../../../components/common/blogCard";
import GreatAward from '../../../assests/images/greataward.webp';
import SliderImage from '../../../assests/images/slider_image.webp';
import {
  Title,
  WriteReviewBannerSection,
  ReviewText,
  ReviewRightSection,
  RightBanner,
} from "../../../components/common/commonSubBanner/commonSubBannerStyle";
import StoryBanner from "../../../assests/images/storybanner.webp";
import { MESSAGE } from '../../../utils/message';
import { useEffect } from 'react';
import { nonprofitMissionHandler } from '../../../redux/slices/nonProfit/nonprofit-mission';
import { useSelector, useDispatch } from 'react-redux';
import MetaComponent from "../../../components/common/metaComponent";

const OurStory = () => {
  const dispatch: any = useDispatch();
  const nonprofitMission = useSelector((state: any) => state?.nonprofitMission?.data?.data);
  useEffect(() => {
    dispatch(nonprofitMissionHandler())
  }, [])
  return (
    <>
      <MetaComponent
        keywords="Yelp, Review Site, Nonprofits"
        description="GreatNonprofits is the Yelp for nonprofits. Helping individuals, donors, volunteers find trustworthy nonprofits."
        ogTitle="Our Story"
        ogDescription="GreatNonprofits is the Yelp for nonprofits. Helping individuals, donors, volunteers find trustworthy nonprofits."
        ogUrl="https://www.about.greatnonprofits.org/our-story"
        ogImage="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"
      />
      <OurStoryBanner>
        <WriteReviewBannerSection className="our-story-banner">
          <Container className="cont-w">
            <Row>
              <Col lg={6} sm={12} md={12} className="toprated test">
                <Title className='story-tile'>GreatNonprofits is the Leading Platform for Community- sourced Stories & Reviews About Nonprofits</Title>
                <ReviewText>The stories and reviews are submitted by people who know you best - - your clients, donors, volunteers, and others-- all those who have experienced the impact of nonprofit work up close!</ReviewText>
              </Col>
              <Col lg={6} sm={12} md={12}>
                <RightBanner className="left_banner">
                  <ReviewRightSection>
                    <Image src={StoryBanner} alt="ReviewImage" />
                  </ReviewRightSection>
                </RightBanner>
              </Col>
            </Row>
          </Container>
        </WriteReviewBannerSection>
      </OurStoryBanner>
      <OurStorySection>
        <Container className="cont-w">
          <OurStoryImage>
            <Image src={Story} alt="Story" />
          </OurStoryImage>
          <Row>
            <Col lg={6} md={12}>
              <StoryGreatNonprofits >
                <StoryTitle>The Story of GreatNonprofits</StoryTitle>
                <StoryText> When Hurricane Katrina hit, the founder of GreatNonprofits,
                  Perla Ni was the publisher of the Stanford Social Innovation Review
                  (www.ssireview.org). She was asked by corporations and individuals who to donate
                  to in places impacted, such as Biloxi, Mississippi</StoryText>
                <StoryText> "I learned about several excellent,
                  local nonprofits through one of our journalists who went to Biloxi.
                  He asked people which nonprofits had been there to help them.
                  He learned about a couple of small nonprofits who were distributing water and helping
                  people living in their cars.</StoryText>
                <StoryText><strong>It was clear that donors and prospective volunteers needed
                  this kind of on-the-ground view from the community.</strong> We needed an online
                  "Tripadvisor for Nonprofits” - to give a voice to the experiences of clients
                  of nonprofits, volunteers, and involved donors. And to help prospective donors
                  and supporters find great nonprofits."</StoryText>
                <StoryText> Since its founding in 2007, GreatNonprofits
                  has quickly grown into the leading provider of reviews and ratings of nonprofit
                  organizations throughout the U.S. Our review methodology takes into account the
                  diversity of the nonprofit sector -- we host reviews of groups of all different
                  shapes and sizes and types from the smallest grassroots groups operating on the
                  local level, to the large regional, national, and international organizations.</StoryText>
              </StoryGreatNonprofits>
            </Col>
            <Col lg={6} md={12}>
              <StoryImageSection>
                <Image src={StoryGreatImage} alt="StoryGreatImage" />
              </StoryImageSection>
            </Col>
          </Row>
          <GreatNonprofitsMission>
            <StoryTitle>GreatNonprofits' Mission</StoryTitle>
            <Row>
              <BlogCard blogData={nonprofitMission} />
            </Row>
          </GreatNonprofitsMission>
          <GreatNonprofitsGreen>
            <GreatImage><Image src={GreatAward} alt="GreatAward" /></GreatImage>
            <GreatGreenText>{MESSAGE.ourStoryBadge}</GreatGreenText>
          </GreatNonprofitsGreen>
          <NonprofitSlider>
            <SliderTitle>{MESSAGE.shareStoryWith}</SliderTitle>
            <SliderWrapper>
              <SliderSwiperItem>
                <Swiper
                  pagination={{ clickable: true, }}
                  loop={true}
                  autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                  }}
                  modules={[Pagination, Autoplay]}
                  className="mySwiper">
                  <SwiperSlide>
                    <Image src={SliderImage} alt="SliderImage" />
                    <SliderItemTitle> {MESSAGE.greatNonprofitsAndFoundant} </SliderItemTitle>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={SliderImage} alt="SliderImage" />
                    <SliderItemTitle> {MESSAGE.greatNonprofitsAndFoundant}</SliderItemTitle>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={SliderImage} alt="SliderImage" />
                    <SliderItemTitle>  {MESSAGE.greatNonprofitsAndFoundant}</SliderItemTitle>
                  </SwiperSlide>
                  <SwiperSlide>
                    <Image src={SliderImage} alt="SliderImage" />
                    <SliderItemTitle> {MESSAGE.greatNonprofitsAndFoundant}</SliderItemTitle>
                  </SwiperSlide>
                </Swiper>
              </SliderSwiperItem>
            </SliderWrapper>
          </NonprofitSlider>
          <NonprofitOrganization>
            <StoryTitle>GreatNonprofits is a Nonprofit Organization</StoryTitle>
            <OrganizationText><strong>GreatNonprofits is a nonprofit organization itself,</strong> which is funded by foundations and individuals who believe that we provide a vital resource for nonprofits, volunteers and donors.</OrganizationText>
            <OrganizationText>It has received media coverage in the Economist, Huffington Post, and Wall Street Journal. GreatNonprofits is led by a seasoned nonprofit executive, Perla Ni, founder and former publisher of the Stanford Social Innovation Review.</OrganizationText>
            <OrganizationText>For questions, drop us a line at <strong>
              <a href="mailto:support@greatnonprofits.org">
                support@greatnonprofits.org
              </a>
            </strong>
            </OrganizationText>
          </NonprofitOrganization>
        </Container>
      </OurStorySection>
    </>
  )
};
export default OurStory; 